class NpcAdminsController {
    static $inject = ["$q", "$location", "stToast", "tpsrService"];

    constructor($q, $location, stToast, tpsrService) {
        this.$q = $q;
        this.$location = $location;
        this.toast = stToast;
        this.tpsr = tpsrService;
        this.users = [];
        this.customers = [];
        this.paging = {
            size: 100,
            number: 1,
            totalQty: 0,
            orderBy: "last_name",
            orderDescending: false
        };
    }

    $onInit() {
        return this.$q.all([
            this._loadUsers(),
            this._loadCustomers()
        ]);
    }

    addUserClicked = () => {
        this.$location.url(`/npc-admins/create`);
    };

    editClicked = user => {
        this.$location.url(`/npc-admins/${user.user_id}`);
    };

    usersClicked = customer => {
        this.tpsr.customer = customer;
        this.$location.url(`/customers/${customer.PIMS_customer_id}/users`)
    };

    toggleRoleClicked = (user, propName, currVal) => {
        return this.tpsr.userToggleRole(user.user_id, propName, !currVal);
    };

    _loadUsers = () => {
        return this.tpsr.getNpcAdmins(this.paging.size, this.paging.number, this.paging.orderBy, this.paging.orderDescending)
            .then(result => {
                this.users = result.users;
                this.paging.totalQty = result.totalQty;
            });
    };

    _loadCustomers = () => {
        return this.tpsr.getCustomers().then(result => this.customers = result);
    };
}

angular
    .module("app")
    .component("npcAdmins", { // npc-admins
        templateUrl: "src/app/npcAdmins/npcAdmins.html",
        controller: NpcAdminsController
    });
